import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import { Link } from "routes";

const styles = theme => ({ 
  chipRoot:{
    display: 'flex',
    flexWrap: 'wrap',
    overflowX: 'scroll',
  },
  divider:{
    backgroundColor: '#e8e3de',
    margin: '20px 0px'
  },
  chip: {
    margin: '8px 8px 8px 0px',
    textTransform: 'uppercase',
    cursor: 'pointer'
  },
})

class TagChips extends Component {
  render() {
    const { classes, tagChips } = this.props;
    return (
        tagChips.length != 0 ?
            <div>
            <Divider className={classes.divider} />
            <h3 style={{fontWeight: 500, margin: '0px 0px 8px',paddingTop: 8}}>ဆက်စပ်အကြောင်းအရာများ</h3>
            <div className={classes.chipRoot}>
                {
                   tagChips.map((tag,i) =>{
                    const slug = tag.slug;
                    const isCOVIDCat = slug == "covid-19" || slug == "COVID-19";
                    const isCOVIDSubCat = slug.includes("covid-19-");
                    const isWuhanTag = slug == "ဝူဟန်_Wuhan";

                    const newString = slug.replace(/_|-/g, " ")
                        .replace(/([A-Z])/g, ' $1').trim();
                    let uniOrZgString = fontUniOrConvertZawgyi(newString);
                    let route = isCOVIDCat ? "category" : isCOVIDSubCat ? "subCategory" : "tagItems";
                    let params = isCOVIDCat ? { category: slug } : isCOVIDSubCat ? { category: "covid-19", subCategory: slug } : { tag: slug };
                    if(isWuhanTag){
                      return null;
                      // route = "category";
                      // params = { category: "covid-19" };
                      // uniOrZgString = "Wuhan-City";
                    }
                    return(
                    <Link key={i} route={route} params={params}>
                        <a className="anchor-link">
                        <Chip label={<span className="tag-article-trigger-gtm">{uniOrZgString}</span>} color="primary" className={classes.chip} />
                        </a>
                    </Link>
                
                    )
                    })
                }
            </div>
            </div>
        : null
    );
  }
}

export default withStyles(styles)(TagChips);
